export default function (date = new Date(), id = 0)
{
    // quarter is 0-based here
    let quarter = Math.floor(date.getMonth() / 3),
        year = date.getFullYear();

    quarter -= id;

    if(quarter < 0)
    {
        let yearsChanged = Math.ceil(-quarter / 4);
        year -= yearsChanged;
        // Shift quarter back to a nonnegative number
        quarter += 4 * yearsChanged;
    }

    return {
        q: quarter + 1,
        year
    };
}